import React, { useState } from "react";
import "./filter.css";
import Button from "../ButtonComponent/Button";
import TextInput from "../TextInputComponent/TextInput";
import DropdownArrow from "../../assets/images/dropdownArrow.svg";
import DropdownList from "../../constants/contentFile.json";
import DropDownItem from "../DropDownComponent/DropDown";
import { Col, Row } from "react-bootstrap";
import CriteriaContent from "../../constants/contentFile.json";
import { Spinner } from "react-bootstrap";

const FilterComponent = ({
  submitFilter,
  filterCriteria,
  setFilterCriteria,
  employeeData,
  setEmployeeData,
  categoryRequired,
  employeeCodeRequired,
  spinnerStatus,
}) => {
  const filterContent = DropdownList.filterComponent;
  const criteriaList = DropdownList.filter;
  const [employeeValidate, setEmployeevalidate] = useState(true);

  return (
    <div className="filter-outer-container">
      <Col lg={12}>
        <Row>
          <Col lg={12} className="filterText">
            {filterContent.filter}
          </Col>
          <Col lg={12}>
            <DropDownItem
              selectedItem={filterCriteria}
              setSelectedItem={setFilterCriteria}
              categoryRequired={categoryRequired}
              list={criteriaList}
            />
          </Col>
          <Col lg={12}>
            <div
              className={
                employeeCodeRequired == true
                  ? "employeeCode employee-validate"
                  : "employeeCode"
              }
            >
              {filterCriteria.name == "Employee Code/name" ? (
                <TextInput
                  value={
                    employeeData === CriteriaContent.filter[5].placeholder
                      ? ""
                      : employeeData
                  }
                  placeholder={employeeData}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/^[^\S]$/, "");
                    setEmployeeData(value);
                  }}
                />
              ) : null}
            </div>
          </Col>
          <Col lg={12} className="button-container">
            <Button
              text={
                spinnerStatus ? <Spinner size="sm" /> : filterContent.submit
              }
              onClick={() => {
                submitFilter();
              }}
            />
          </Col>
        </Row>
      </Col>
    </div>
  );
};

export default FilterComponent;
